import Image from 'next/image';

export type BrandMarkProps = {
  size?: number;
  className?: string;
  priority?: boolean;
};

/** App logo mark (square icon PNG from /logo-icon.png). */
export function BrandMark({ size = 36, className = '', priority = false }: BrandMarkProps) {
  return (
    <Image
      src="/logo-icon.png"
      alt=""
      width={size}
      height={size}
      className={className}
      priority={priority}
      aria-hidden
    />
  );
}
